import store from 'src/store';
import requestErrorParser from '@helpers/requestErrorParser';
import { authService } from 'src/services/authService';
import { ApiError } from 'src/errors/ApiError';
import fetchMetadata from '@api/base/fetchMetadata';
import { logApiError, newRequestId } from '@api/base/apiLogger';
import { isInternalPage } from '@utils/redirections';
import { isVerboseDebugEnabled } from '@utils/debugMode';

declare const HIDE_NETWORK_LOGS: boolean;

export default <T>(client, method, request = null): Promise<T> => {
  return fetchMetadata().then((rawMetadata) => {
    const requestId = newRequestId();
    const metadata = { ...rawMetadata, 'x-request-id': requestId };

    if (isVerboseDebugEnabled()) {
      if (HIDE_NETWORK_LOGS !== true) {
        console.group(`>> ${method.name}`);
        console.info(structuredClone(metadata));
        if (request != null) {
          if (request.toObject) {
            console.info(structuredClone(request.toObject()));
          } else {
            console.info(structuredClone(request.array));
          }
        }
        console.groupEnd();
      }
    }

    const startedAt = performance.now();

    return new Promise((resolve, reject) => {
      const resData = [];
      const stream = method.call(client, request, metadata);

      stream.on('data', (res) => {
        resData.push(res.toObject());
      });

      stream.on('status', (status) => {
        if (status.code !== 0) {
          const errorMessage = status.errorMessage || status.message || status.details;

          logApiError({
            methodName: method.name,
            code: status.code,
            message: errorMessage,
            requestId,
            startedAt,
            grpcMetadata: status.metadata || status.trailers,
          });

          if (isVerboseDebugEnabled()) {
            if (HIDE_NETWORK_LOGS !== true) {
              console.group(`<< ${method.name}`);
              console.error(status);
              console.groupEnd();
            }
          }

          if (errorMessage) {
            store.dispatch(requestErrorParser(errorMessage, false, requestId));
          }

          if (status.code === 16 && isInternalPage(window.location.pathname)) {
            authService.logout();
          }
          reject(new ApiError(errorMessage, status.code, status, requestId));
        }
      });

      stream.on('end', () => {
        if (isVerboseDebugEnabled()) {
          if (HIDE_NETWORK_LOGS !== true) {
            console.group(`<< ${method.name}`);
            console.info(structuredClone(resData));
            console.groupEnd();
          }
        }

        // @ts-ignore
        resolve(resData);
      });
    });
  });
};
